import { useContext } from 'react';

import { AlertContext } from './context';

export const useAlert = () => {
  const alertState = useContext(AlertContext);
  return alertState;
};
